import { IVarDocumentationProps, QueryParameter, RequestBody } from "../../../interfaces/OpenAPI";

export const getDocumentationProgressProps = ({ intl, settings }: IVarDocumentationProps) => {
    // ===================== GET PROGRESS =====================
    const getProgressExample = {
        "success": true,
        "message": "Berhasil mendapatkan Progress.",
        "data": [
            {
                "color": "#178f64",
                "creator_id": "991n1221-56f8-4dc9-888b-e8de64c47b85",
                "creator_name": "Nama Pembuat",
                "date_created": "2023-11-15 14:44:26",
                "id": "op001jk1-33ee-4ab6-ba7b-e791244c208c",
                "isRequiredAttachment": false,
                "isRequiredUpdateProductHpp": true,
                "isSplittable": false,
                "name": "FOLLOW-UPS",
                "progress_type": "ONGOING",
                "sub_progress": [
                    {
                        "id": "opa001ad-f789-4f36-bbc3-67737ab5cbf5",
                        "name": "MEETING"
                    }
                ]
            }
        ]
    };

    const python_get_progress = `
    import requests
    import json

    reqUrl = "https://crm-api.wooblazz.com/lead_progresses"
    token = //${intl.formatMessage({ id: "OPEN_API.DESC_TOKEN" })}

    headersList = {
    "Accept": "*/*",
    "Content-Type": "application/json", 
    "X-Auth-token": token
    }

    response = requests.request("GET", reqUrl, headers=headersList)
    print(response.text)
    `

    const javascript_get_progress = `
    const axios = require('axios');

    const reqUrl = "https://crm-api.wooblazz.com/lead_progresses";
    const token = //${intl.formatMessage({ id: "OPEN_API.DESC_TOKEN" })};

    const headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json",
        "X-Auth-token": token
    };

    axios.get(reqUrl, { headers: headersList })
        .then((response) => {
            console.log(response.data);
        })
        .catch((error) => {
            console.error(error);
        });

    `

    const php_get_progress = `
    <?php

    $reqUrl = "https://crm-api.wooblazz.com/lead_progresses";
    $token = //${intl.formatMessage({ id: "OPEN_API.DESC_TOKEN" })};

    $headersList = [
        "Accept: */*",
        "Content-Type: application/json",
        "X-Auth-token: $token"
    ];

    $ch = curl_init();

    curl_setopt($ch, CURLOPT_URL, $reqUrl);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    curl_setopt($ch, CURLOPT_HTTPHEADER, $headersList);

    $response = curl_exec($ch);

    if (curl_errno($ch)) {
        echo 'Error: ' . curl_error($ch);
    } else {
        echo $response;
    }

    curl_close($ch);

    ?>

    `

    const bash_get_progress = `
    curl -X GET
    "https://crm-api.wooblazz.com/lead_progresses"
    -H "Accept: */*" 
    -H "Content-Type: application/json" 
    -H "X-Auth-token: //${intl.formatMessage({ id: 'OPEN_API.DESC_TOKEN' })}"
    `

    return { bash_get_progress, python_get_progress, php_get_progress, javascript_get_progress, getProgressExample }
}